import { ButtonProps } from '@material-ui/core/Button'
import styled, { css } from 'styled-components'
import Button from '../StyledButton'
import { colors } from '../../styles'

export const DangerButton = styled(Button)<ButtonProps>`
  background: ${colors.red};
  color: ${colors.white};
  &:hover {
    background-color: ${colors.red10};
  }

  ${({ variant }) => {
    switch (variant) {
      case 'text':
        return css`
          background: ${colors.white};
          color: ${colors.red};
          &:hover {
            background-color: ${colors.red80};
          }
        `
      case 'outlined':
        return css`
          background: ${colors.white};
          border: 1px solid ${colors.red};
          color: ${colors.red};
          &:hover {
            background-color: ${colors.red80};
          }
        `
    }
  }}
`
